import { Box } from "@mui/material";
import { STATUS_TO_ICON_MAP } from "Components/Shared/Transactions/transactionsUtils";
import type { TransactionStatus } from "Infrastructure/Api/Api";

type Props = {
  status: TransactionStatus;
};

export const TransactionIcon = ({ status }: Props) => (
  <Box component="span" width={24} display="flex" justifyContent="center">
    {STATUS_TO_ICON_MAP[status]}
  </Box>
);
